import { render } from "./city-detail.vue?vue&type=template&id=382aaa28"
import script from "./city-detail.vue?vue&type=script&lang=js"
export * from "./city-detail.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__